@if (mappedFooterContentSections$ | async; as mappedFooterContentSections) {
  <div class="mt-[260px] md:mt-60 mx-4 w-full flex flex-col">
    @if (mappedFooterContentSections['liveOnStage']; as sectionData) {
      <h4 class="footer-header text-center">
        {{ sectionData.footerSectionTitle }}
      </h4>
      @for (link of sectionData.footerSectionLinks; track $index) {
        <a
          class="py-4 px-2 w-full text-center footer-link relative"
          [routerLink]="[link.page?.url ?? link.url]"
          >{{ link.text }}
          <hr
            class="w-full border-t-2 border-ss-www-background absolute bottom-0 left-0 right-0"
          />
        </a>
      }
    }
    <div class="mt-6 flex flex-row gap-2.5">
      <div class="w-1/2 relative">
        @if (mappedFooterContentSections['featureFilms']; as sectionData) {
          <h4 class="footer-header text-center">
            {{ sectionData.footerSectionTitle }}
          </h4>
          @for (link of sectionData.footerSectionLinks; track $index) {
            <a
              [routerLink]="[link.page?.url ?? link.url]"
              class="block py-4 px-1 w-full text-center footer-link"
              >{{ link.text }}</a
            >
          }
          <hr
            class="w-full border-t-2 border-ss-www-background absolute bottom-0 left-0 right-0"
          />
        }
      </div>
      <div class="w-1/2 relative">
        @if (mappedFooterContentSections['streaming']; as sectionData) {
          <h4 class="footer-header text-center">
            {{ sectionData.footerSectionTitle }}
          </h4>
          @for (link of sectionData.footerSectionLinks; track $index) {
            <a
              [routerLink]="[link.page?.url ?? link.url]"
              class="block py-4 px-1 w-full text-center footer-link"
              >{{ link.text }}</a
            >
          }
          <hr
            class="w-full border-t-2 border-ss-www-background absolute bottom-0 left-0 right-0"
          />
        }
      </div>
    </div>
    <ss-accordion class="w-full block mx-auto mt-7" styling="menu">
      @for (section of dropdownSections; track $index) {
        @if (mappedFooterContentSections[section]; as sectionData) {
          <ss-accordion-item>
            <h5
              class="font-brandon text-[15px] font-medium tracking-widest"
              ssAccordionItemTitle
            >
              {{ sectionData.footerSectionTitle }}
            </h5>
            <ul>
              @for (link of sectionData.footerSectionLinks; track $index) {
                <li
                  class="flex justify-center px-2 py-4 border-t-2 border-solid border-ss-www-background bg-black last:rounded-b-xl"
                >
                  @if (!link.page?.url && link.url?.startsWith('http')) {
                    <a class="font-light text-[17px]" [href]="link.url">{{
                      link.text
                    }}</a>
                  } @else {
                    <a
                      class="font-light text-[17px]"
                      [routerLink]="[link.page?.url ?? link.url ?? '#']"
                      >{{ link.text }}</a
                    >
                  }
                </li>
              }
            </ul>
          </ss-accordion-item>
        }
      }
    </ss-accordion>
    @for (section of infoSections; track $index) {
      <div class="mt-9 flex flex-col justify-center text-center items-center">
        @if (mappedFooterContentSections[section]; as sectionData) {
          <h4 class="footer-header text-center mb-2">
            {{ sectionData.footerSectionTitle }}
          </h4>
          @for (link of sectionData.footerSectionLinks; track $index) {
            @if (link.url) {
              <a
                class="footer-link ss-no-border max-w-[250px]"
                [href]="link.url"
                [innerHTML]="link.text"
              >
              </a>
            } @else {
              <p class="footer-link ss-no-border max-w-[250px]">
                {{ link.text }}
              </p>
            }
            @if (link.subText) {
              <p class="footer-subtext mt-2">
                {{ link.subText }}
              </p>
            }
          }
        }
      </div>
    }
    <!-- Hasta aqui links reutilizables -->
    <div class="mt-10 flex flex-row gap-10 justify-center">
      @for (social of socialLinks$ | async; track $index) {
        <a
          class="transform hover:scale-110 transition ease-out"
          [href]="social?.url"
          target="_blank"
        >
          <ss-www-image-with-loader
            class="w-10 aspect-square"
            [fileDetail]="social?.image"
            desktopImageSize="full"
          ></ss-www-image-with-loader>
        </a>
      }
    </div>
    <div class="mt-8 flex justify-center">
      <ss-button
        class="w-full max-w-[342px]"
        buttonStyle="outlined"
        buttonColor="principal"
        routerLink="/contact-us"
        >CONTACT US</ss-button
      >
    </div>
    <div class="flex flex-col mt-9">
      <a
        href="https://ticketcenter.sight-sound.com"
        class="py-4 px-2 w-full text-center footer-link border-b-2 border-ss-www-background"
        >Reseller Login</a
      >
      <a
        href="https://centerstage.sight-sound.com"
        class="py-4 px-2 w-full text-center footer-link border-b-2 border-ss-www-background"
        >Employee Login</a
      >
    </div>
    <div class="flex justify-center mt-10">
      <ss-www-ampersand-logo></ss-www-ampersand-logo>
    </div>
    <p class="ss-copyright-message mt-8">
      Copyright<span class="ss-superscript">©</span> {{ year }}, Sight & Sound
      Ministries Inc. <br />All Rights Reserved.
    </p>
    @for (list of policyLinks; track $index; let rowLast = $last) {
      <ul
        class="mt-2 flex flex-row gap-2 justify-center flex-wrap"
        [ngClass]="{ 'mb-24': rowLast }"
      >
        @for (item of list; track $index; let isLast = $last) {
          @if (!item.page?.url && item.url?.startsWith('http')) {
            <a
              class="ss-footer-policy-links text-white underline"
              [href]="item.url"
              >{{ item.text }}</a
            >
          } @else {
            <a
              class="ss-footer-policy-links text-white underline"
              [routerLink]="[item.page?.url ?? item.url ?? '#']"
              >{{ item.text }}</a
            >
          }
          @if (!isLast) {
            <span class="text-white">&#8226;</span>
          }
        }
      </ul>
    }
  </div>
}
